// extracted by mini-css-extract-plugin
export default {"formVideoBox":"index_formVideoBox_Y6vKw","formVideoButton":"index_formVideoButton_RwK5n","formVideoUploadInput":"index_formVideoUploadInput_AASW-"};